// add here all things needed for loan in app details
import gql from 'graphql-tag'

export default gql`
  mutation updateData($input: ModelAttributeInput!) {
    modelAttribute(input: $input) {
      errors {
        field
        message
      }
      loan {
        id
        rid
        businesses {
          borrowerType
          questions {
            number
            description
            selectOptions
          }
          answers {
            rid
            value
            type
            questionNumber
          }
        }
      }
    }
  }
`
